var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72153 0.295367C1.3277 -0.0984556 0.68919 -0.0984557 0.295367 0.295367C-0.0984556 0.68919 -0.0984557 1.3277 0.295367 1.72153L3.62307 5.04923C4.14817 5.57432 4.14817 6.42567 3.62307 6.95077L0.295367 10.2785C-0.0984556 10.6723 -0.0984556 11.3108 0.295367 11.7046C0.68919 12.0985 1.3277 12.0985 1.72153 11.7046L5.04923 8.37693C5.57432 7.85183 6.42567 7.85183 6.95077 8.37693L10.2785 11.7046C10.6723 12.0985 11.3108 12.0985 11.7046 11.7046C12.0985 11.3108 12.0985 10.6723 11.7046 10.2785L8.37693 6.95077C7.85183 6.42567 7.85183 5.57432 8.37693 5.04923L11.7046 1.72153C12.0985 1.3277 12.0985 0.68919 11.7046 0.295368C11.3108 -0.0984553 10.6723 -0.0984556 10.2785 0.295367L6.95077 3.62307C6.42567 4.14817 5.57432 4.14817 5.04923 3.62307L1.72153 0.295367Z",
    fill: "#00C880"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconGreen);
export default __webpack_public_path__ + "static/media/closeIconGreen.b804c30f36c15113f2f510f275634fe4.svg";
export { ForwardRef as ReactComponent };